import { useEffect, useState } from "react";
import { View } from "./View";

export interface IPasswordStrengthIndicatorProps {
  password: string;
  touched: boolean;
  minimumLength?: number;
  maximumLength?: number;
  validateLowerCase?: boolean;
  validateUpperCase?: boolean;
  validateDigitPresent?: boolean;
  validateSpecialCharacter?: boolean;
  // validatexxxxxxxx?: boolean;
}

export interface IPasswordStrengthIndicatorViewProps
  extends IPasswordStrengthIndicatorProps {
  hideIndicator: boolean;
  isMinLengthValid: boolean;
  isMaxLengthValid: boolean;
  isLowerCaseValid: boolean;
  isUpperCaseValid: boolean;
  isDigitPresentValid: boolean;
  isSpecialCharacterValid: boolean;
}

export const PasswordStrengthIndicator = (
  props: IPasswordStrengthIndicatorProps
) => {
  const {
    password,
    minimumLength,
    maximumLength,
    validateLowerCase,
    validateUpperCase,
    validateDigitPresent,
    validateSpecialCharacter,
    // validatexxxxxxxx
  } = props;

  const isMinLengthValid =
    !minimumLength || (!!password && password.length >= minimumLength);
  const isMaxLengthValid =
    !maximumLength || (!!password && password.length <= maximumLength);
  const isLowerCaseValid =
    !validateLowerCase || (!!password && /\w*[a-z]\w*/.test(password));
  const isUpperCaseValid =
    !validateUpperCase || (!!password && /\w*[A-Z]\w*/.test(password));
  const isDigitPresentValid =
    !validateDigitPresent || (!!password && /\d/.test(password));
  const isSpecialCharacterValid =
    !validateSpecialCharacter ||
    (!!password && /[!@#$%^&*()\-_"=+{}; :,<.>]/.test(password));
  // const isxxxxxxxxValid = !validatexxxxxxxx || xxxxxxxx;

  const isAllValid =
    isMinLengthValid &&
    isMaxLengthValid &&
    isLowerCaseValid &&
    isUpperCaseValid &&
    isDigitPresentValid &&
    isSpecialCharacterValid;

  // console.log("touched: ", props.touched);

  // console.log("isAllValid: ", isAllValid);
  // console.log("isMinLengthValid: ", isMinLengthValid);
  // console.log("isMaxLengthValid: ", isMaxLengthValid);
  // console.log("isLowerCaseValid: ", isLowerCaseValid);
  // console.log("isUpperCaseValid: ", isUpperCaseValid);
  // console.log("isDigitPresentValid: ", isDigitPresentValid);
  // console.log("isSpecialCharacterValid: ", isSpecialCharacterValid);

  const [hideIndicator, setHideIndicator] = useState(isAllValid);

  let timeOutId: NodeJS.Timeout;
  useEffect(() => {
    timeOutId = setTimeout(() => setHideIndicator(isAllValid), 1000);

    return () => timeOutId && clearTimeout(timeOutId);
  }, [isAllValid]);

  return (
    <View
      hideIndicator={hideIndicator}
      isMinLengthValid={isMinLengthValid}
      isMaxLengthValid={isMaxLengthValid}
      isLowerCaseValid={isLowerCaseValid}
      isUpperCaseValid={isUpperCaseValid}
      isDigitPresentValid={isDigitPresentValid}
      isSpecialCharacterValid={isSpecialCharacterValid}
      {...props}
    />
  );
};
